/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/CroppingConfiguration.yaml
import { Palette } from '../../ui_v2/common/Common';
import { CroppingScreenConfiguration } from '../../ui_v2/document/CroppingScreenConfiguration';
import { CroppingTextLocalization } from '../../ui_v2/document/CroppingTextLocalization';
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of the general appearance for the cropping screen.
*/
export class CroppingAppearanceConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CroppingAppearanceConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Determines the visual mode used for the status bar icons.
          
          Default is LIGHT
          */
        this.statusBarMode = 'LIGHT';
        /**
          Determines the visual mode used for the navigation bar icons. Android only.
          
          Default is LIGHT
          */
        this.navigationBarMode = 'LIGHT';
        /**
          The background color of the top bar. Only applicable when the visual mode is specified as 'SOLID', otherwise ignored.
          
          Default is "?sbColorPrimary"
          */
        this.topBarBackgroundColor = '?sbColorPrimary';
        /**
          The background color of the bottom bar.
          
          Default is "?sbColorPrimary"
          */
        this.bottomBarBackgroundColor = '?sbColorPrimary';
        /**
          Which mode to use when orientation should be locked to landscape or portrait.
          
          Default is NONE
          */
        this.orientationLockMode = 'NONE';
        if (source.statusBarMode !== undefined) {
            this.statusBarMode = source.statusBarMode;
        }
        if (source.navigationBarMode !== undefined) {
            this.navigationBarMode = source.navigationBarMode;
        }
        if (source.topBarBackgroundColor !== undefined) {
            this.topBarBackgroundColor = source.topBarBackgroundColor;
        }
        if (source.bottomBarBackgroundColor !== undefined) {
            this.bottomBarBackgroundColor = source.bottomBarBackgroundColor;
        }
        if (source.orientationLockMode !== undefined) {
            this.orientationLockMode = source.orientationLockMode;
        }
    }
}
/**
Configuration of the standalone cropping screen.
*/
export class CroppingConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CroppingConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Version number of the configuration object.
          
          Default is "1.0"
          */
        this.version = '1.0';
        /**
          The configuration object should be applied for this screen.
          
          Default is "CroppingConfiguration"
          */
        this.screen = 'CroppingConfiguration';
        /**
          Define the screen's base color values from which other colors are derived.
          */
        this.palette = new Palette({
            sbColorPrimary: '#C8193C',
            sbColorPrimaryDisabled: '#F5F5F5',
            sbColorNegative: '#FF3737',
            sbColorPositive: '#4EFFB4',
            sbColorWarning: '#FFCE5C',
            sbColorSecondary: '#FFEDEE',
            sbColorSecondaryDisabled: '#F5F5F5',
            sbColorOnPrimary: '#FFFFFF',
            sbColorOnSecondary: '#C8193C',
            sbColorSurface: '#FFFFFF',
            sbColorOutline: '#EFEFEF',
            sbColorOnSurfaceVariant: '#707070',
            sbColorOnSurface: '#000000',
            sbColorSurfaceLow: '#00000026',
            sbColorSurfaceHigh: '#0000007A',
            sbColorModalOverlay: '#000000A3',
        });
        /**
          Configuration of all the strings for the standalone cropping screen.
          */
        this.localization = new CroppingTextLocalization({});
        /**
          Configuration of the general appearance for the cropping screen.
          */
        this.appearance = new CroppingAppearanceConfiguration({});
        /**
          Configuration of the cropping screen.
          */
        this.cropping = new CroppingScreenConfiguration({});
        /**
          Determines if the quality analysis for the acknowledgement mode will run on the filtered or the unfiltered image.
          
          Default is UNFILTERED_DOCUMENT
          */
        this.documentAnalysisMode = 'UNFILTERED_DOCUMENT';
        if (source.version !== undefined) {
            this.version = source.version;
        }
        if (source.screen !== undefined) {
            this.screen = source.screen;
        }
        if (source.palette !== undefined) {
            this.palette = new Palette(source.palette);
        }
        if (source.documentUuid !== undefined) {
            this.documentUuid = source.documentUuid;
        }
        else {
            throw new Error('documentUuid must be present in constructor argument');
        }
        if (source.pageUuid !== undefined) {
            this.pageUuid = source.pageUuid;
        }
        else {
            throw new Error('pageUuid must be present in constructor argument');
        }
        if (source.localization !== undefined) {
            this.localization = new CroppingTextLocalization(source.localization);
        }
        if (source.appearance !== undefined) {
            this.appearance = new CroppingAppearanceConfiguration(source.appearance);
        }
        if (source.cropping !== undefined) {
            this.cropping = new CroppingScreenConfiguration(source.cropping);
        }
        if (source.documentAnalysisMode !== undefined) {
            this.documentAnalysisMode = source.documentAnalysisMode;
        }
    }
}
//# sourceMappingURL=CroppingConfiguration.js.map